<script>
  import { Dropdown } from 'sveltestrap'

  import { _ } from 'svelte-i18n'

  import LanguageDropdown from '../../common/LanguageDropdown.svelte'

  import NotificationDropdown from '../../common/NotificationDropdown.svelte'
  import ProfileMenu from '../../common/ProfileMenu.svelte'

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  function tToggle() {
    var body = document.body

    body.classList.toggle('sidebar-enable')
    body.classList.toggle('vertical-collpsed')

    if (window.innerWidth >= 992) {
      if (body.getAttribute('data-sidebar-size') == 'sm') {
        body.setAttribute('data-sidebar-size', 'lg')
      } else {
        body.setAttribute('data-sidebar-size', 'sm')
      }
    }
  }

  export let sidebar = false

  async function getData() {
    window.location.reload()
  }
</script>

<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a href="/" class="logo logo-dark">
          <span class="logo-sm">
            <img
              src="/assets/images/1.jpg"
              alt="0"
              height="100%"
              width="100%"
            />
          </span>
          <span class="logo-lg">
            <img
              src="/assets/images/logo_das.png"
              alt=""
              height="100%"
              width="50%"
            />
          </span>
        </a>

        <a href="index" class="logo logo-light">
          <span class="logo-sm">
            <img src="/assets/images/logo-light.svg" alt="" height="22" />
          </span>
          <span class="logo-lg">
            <img src="/assets/images/logo-light.png" alt="" height="19" />
          </span>
        </a>
      </div>

      <button
        class="btn btn-sm px-3 font-size-16 vertinav-toggle header-item waves-effect"
        id="vertical-menu-btn"
        on:click={tToggle}
      >
        <i class="fa fa-fw fa-bars" />
      </button>
    </div>

    <div class="d-flex">
      <LanguageDropdown on:chageLang={getData} />
      <!--
      <Dropdown class="d-none d-lg-inline-block ms-1">
        <button
          type="button"
          class="btn header-item noti-icon headerbtn"
          on:click={toggleFullscreen}
          data-toggle="fullscreen"
        >
          <i class="bx bx-fullscreen" />
        </button>
      </Dropdown>

      <NotificationDropdown />
-->
      <ProfileMenu />
    </div>
  </div>
</header>
